/* eslint-disable no-nested-ternary */
/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { useDispatch, useSelector } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import {
  rebateProgramLabel,
  quarterRangeLabel,
  unallocatedBalanceLabel,
  URAUsedLabel,
  ARSummaryByQtrrLabel,
  selectRebateProgramLabel,
} from './ConstantData';
import TableGridWithFeatures from '../../../../SharedModules/Table/TableGridWithFeatures';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import suppressNavigation, {
  onCellFocused,
  navigateToNextCell,
  tabToNextCell,
} from '../../../../SharedModules/AgGridUtilities/suppressNavigation';
import { ARSummryByQtrColumns, rebateProgramListColumns } from '../tablehead';
import {
  getUnallocatedBalanceQtr,
  getSingleAccRecQtr,
  selectedRebateList,
  selectedRebateName,
} from './store/actions';
import * as actiontypes from './store/actiontypes';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import Spinner from '../../../../SharedModules/Spinner/SpinnerNew';
import CommonModal from '../ARCommonModal';
import { getArSummaryByQtr } from '../ReqAccReceivable/store/actions';

import { qtrAccRecFieldValues } from '../QtrAccountsRec/store/actions';
import { qtrAccRecAllFieldValues } from '../QtrAccountsRecAll/store/actions';
import ActionDropDownComp, {
  RedTextRenderCompKeyChange,
} from '../ActionDropdownComp';
import RedTextRenderComp from '../RedTextRenderComp';
import * as actiontype from '../ReqAccReceivable/store/actiontypes';
import {
  goToArSummaryQtr,
  goToArSummaryQtrAccountAll,
} from '../ARCommonFunctions';
import CustomGridCellRendererComponent from '../../../../SharedModules/AgGridUtilities/CustomGridCellRenderercomponent';

const formatter = new Intl.NumberFormat('en-US', {
  style: 'currency',
  currency: 'USD',
});
const ARSummaryByQtrAll = (props) => {
  const dispatch = useDispatch();
  const [fullScreenView, setFullScreenView] = React.useState(false);
  const [gridApi, setGridApi] = React.useState(null);
  const [showRebateProgramList, setShowRebateProgramList] =
    React.useState(false);
  const [selectedRebateRow, setSelectedRebateRow] = React.useState([]);
  const [unallocatedBlnQtr, setUnallocatedBlnQtr] = React.useState(0);
  const [pinned, setPinned] = React.useState();
  const [load, setLoad] = React.useState(false);
  const ar_smry_qtr_tbl = useSelector(
    (state) => state?.sharedState?.ArSummaryQtrAllReducer?.ar_smry_qtr_all_tbl
  );
  const ar_smry_qtr_unallocated = useSelector(
    (state) =>
      state?.sharedState?.ArSummaryQtrAllReducer?.ar_smry_qtr_unallocated
  );
  const ar_smry_single_qtr_main = useSelector(
    (state) =>
      state?.sharedState?.ArSummaryQtrAllReducer?.ar_smry_single_qtr_main
  );
  const rebate_list_code = useSelector(
    (state) => state?.sharedState?.ArSummaryQtrAllReducer?.rebate_list_code
  );
  const qtr_field_value = useSelector(
    (state) => state?.sharedState?.ArSummaryQtrAllReducer?.qtr_field_value
  );
  const rebate_pgm_name = useSelector(
    (state) => state?.sharedState?.ArSummaryQtrAllReducer?.rebate_pgm_name
  );
  const { rebate_list, rebate_pgm, qtr_opt, end_qtr, start_qtr, ar_smry_qtr } =
    useSelector((state) => state?.sharedState?.AccountRecReducer);

  // get unallocated balance from redux
  React.useEffect(() => {
    if (ar_smry_single_qtr_main && ar_smry_single_qtr_main.status === '001') {
      goToArSummaryQtrAccountAll(props.history, dispatch);
      dispatch({ type: actiontypes.AR_SMRY_FOR_QTR_SINGLE, payload: null });
    }
  }, [ar_smry_single_qtr_main]);

  const [filteredRows, setFilteredRow] = React.useState([]);
  const [filterApply, setFilterApply] = React.useState(false);
  const getFilterApply = (filterApplied) => {
    setFilterApply(filterApplied);
  };
  const onFilterChanged = (rowData, type) => {
    setFilteredRow(rowData);
  };
  const sum = (property) =>
    filteredRows?.reduce((acc, obj) => acc + obj[property], 0);
  React.useEffect(() => {
    if (filterApply) {
      const data = [
        {
          currBalance: sum('currBalance'),
          offsetDue: sum('offsetDue'),
          baseStateAmountDue: sum('baseStateAmountDue'),
          interestDue: sum('interestDue'),
          totalDue: sum('totalDue'),
          amtPaid: sum('amtPaid'),
          offsetPaidAmt: sum('offsetPaidAmt'),
          origInvAMt: sum('origInvAMt'),
          baseStatePaidAmount: sum('baseStatePaidAmount'),
          baseStateRebateAmt: sum('baseStateRebateAmt'),
          interestPaid: sum('interestPaid'),
          disputeAmt: sum('disputeAmt'),
          revisedReimburseAmt: sum('revisedReimburseAmt'),
          currInvAMt: sum('currInvAMt'),
          currRoa: sum('currRoa'),
          disputeCount: sum('disputeCount'),
          invoices: sum('invoices'),
          actions: 'hide',
          quarter: 'Total:',
          isBottomRow: true,
        },
      ];
      setPinned(data);
    } else {
      const data = [
        {
          currBalance: ar_smry_qtr_tbl?.totalCurrBalance,
          offsetDue: ar_smry_qtr_tbl?.totalOffsetDue,
          baseStateAmountDue: ar_smry_qtr_tbl?.totalBaseStateAmountDue,
          interestDue: ar_smry_qtr_tbl?.totalInterestDue,
          totalDue: ar_smry_qtr_tbl?.finalTotalDue,
          amtPaid: ar_smry_qtr_tbl?.totalAmtPaid,
          offsetPaidAmt: ar_smry_qtr_tbl?.totalOffsetPaidAmt,
          origInvAMt: ar_smry_qtr_tbl?.totalOrigInvAMt,
          baseStatePaidAmount: ar_smry_qtr_tbl?.totalBaseStatePaidAmount,
          baseStateRebateAmt: ar_smry_qtr_tbl?.totalBaseStateRebateAmount,
          interestPaid: ar_smry_qtr_tbl?.totalInterestPaid,
          disputeAmt: ar_smry_qtr_tbl?.totalDisputeAmt,
          revisedReimburseAmt: ar_smry_qtr_tbl?.totalRevisedReimburseAmt,
          currInvAMt: ar_smry_qtr_tbl?.totalCurrInvAMt,
          currRoa: ar_smry_qtr_tbl?.totalCurrRoa,
          disputeCount: ar_smry_qtr_tbl?.totalDisputeCount,
          invoices: ar_smry_qtr_tbl?.totalInvoices,
          actions: 'hide',
          quarter: 'Total:',
          isBottomRow: true,
        },
      ];
      setPinned(data);
    }
  }, [filterApply, filteredRows]);

  // get unallocated balance from redux
  React.useEffect(() => {
    if (ar_smry_qtr_unallocated && ar_smry_qtr_unallocated.status === '001') {
      setUnallocatedBlnQtr(ar_smry_qtr_unallocated.unallocatedBalance || 0);
    }
  }, [ar_smry_qtr_unallocated]);
  // get rebate list from redux and call the unallocated api
  React.useEffect(() => {
    if (rebate_list && rebate_pgm) {
      const payload = {
        rebateProgram: 'All',
        indicator: 1,
      };
      dispatch(getUnallocatedBalanceQtr(payload));
    }
  }, [rebate_list]);
  // redirect Go to quarter account receivable page
  const handleGoToQtrAccRec = (row) => {
    if (row) {
      setLoad(true);
      const payload = {
        rebateProgram: 'All',
        quarter: row.quarter,
        userOfficialUra: qtr_field_value?.uraInfo === 'Official' ? 1 : 0,
      };
      const fieldObj = {
        pgmInfo: 'All',
        pgmCd: rebate_pgm,
        qtrInfo: qtr_field_value?.qtrInfo,
        uraInfo: qtr_field_value?.uraInfo,
      };
      dispatch(qtrAccRecAllFieldValues(fieldObj));
      dispatch(getSingleAccRecQtr(payload));
    }
  };
  // select rebate program list function
  // const selectRebateProgramList = (row) => {
  //   if (row) {
  //     setShowRebateProgramList(true);
  //   }
  // };
  // ag-grid frame work component
  const frameworkComponents = {
    ActionCellRender: (cellInfo) => {
      return (
        // <div className="tdCell dib icon-btn-group" data-testid="action-column">
        //   <Dropdown className="icon-dropdown-container">
        //     <Dropdown.Toggle
        //       className="icon-dropdown export_wrap"
        //       aria-label="export"
        //     >
        //       <OverlayTrigger
        //         placement="bottom"
        //         overlay={<Tooltip id="action-tooltip">Actions</Tooltip>}
        //       >
        //         <SVGComponent iconName="Icon-export1" />
        //       </OverlayTrigger>
        //     </Dropdown.Toggle>
        //     <Dropdown.Menu className="export_dropdown">
        //       <Dropdown.Item
        //         role="button"
        //         onClick={() => handleGoToQtrAccRec(cellInfo?.data)}
        //       >
        //         Go To Quarterly Accounts Receivable
        //       </Dropdown.Item>
        //       <Dropdown.Item
        //         role="button"
        //         onClick={() => selectRebateProgramList(cellInfo?.data)}
        //       >
        //         Select Rebate Program
        //       </Dropdown.Item>
        //     </Dropdown.Menu>
        //   </Dropdown>
        // </div>
        <ActionDropDownComp
          data={cellInfo}
          loadfn={setLoad}
          displayBy="qtrSmry"
          selectPgm
          selectedRebate={redirectRebateList}
          // extraData={qtr_val}
          handleGoToQtrAccRec={handleGoToQtrAccRec}
        />
      );
    },
    NameTextRender: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <b>{cellInfo.value}</b>;
      }
      return cellInfo.value;
    },
    redTextRenderer: (cellInfo) => {
      if (cellInfo.data?.isBottomRow) {
        return <CustomGridCellRendererComponent {...cellInfo} />;
      }
      return <RedTextRenderComp data={cellInfo} />;
    },
    redTextRendererKeyChange: (cellInfo) => {
      return <RedTextRenderCompKeyChange data={cellInfo} />;
    },
  };

  const renderTooltip = (propsTooltip) => {
    return qtr_field_value?.qtrInfo.indexOf('DRAMS') !== -1 ||
      qtr_field_value?.qtrInfo.indexOf('First') !== -1 ? (
      <Tooltip id="add-tooltip" {...propsTooltip}>
        {qtr_field_value?.qtrInfo}
      </Tooltip>
    ) : (
      <p {...propsTooltip} />
    );
  };
  // ongrid ready function
  const onGridReady = (params) => {
    setGridApi(params.api);
  };
  // on row selected
  // const onRowSelect = (val) => {
  //   let [row] = val.api.getSelectedRows();
  //   setSelectedRebateRow([row]);
  //   let rebateProgramCd = [row][0].rebateProgramCd;
  //   let rebateProgramName = [row][0].name;
  //   dispatch(selectedRebateName(rebateProgramName));
  //   dispatch(selectedRebateList(rebateProgramCd));
  // };
  // redirect particular selected rebate list row function
  const redirectRebateList = (row) => {
    if (row) {
      setSelectedRebateRow([row]);
      const { rebateProgramCd } = row;
      const rebateProgramName = `${row.rebateProgramCd} | ${row.shortDescr}`;
      dispatch(selectedRebateName(rebateProgramName));
      dispatch(selectedRebateList(rebateProgramCd));
      setLoad(true);
      const payload = {
        rebateProgram: rebateProgramCd,
        startQuarter: qtr_field_value.startQuarter,
        endQuarter: qtr_field_value.endQuarter,
        useOfficialURA: qtr_field_value?.uraInfo === 'Official' ? 1 : 0,
      };
      const fieldObj = {
        pgmInfo: `${row.rebateProgramCd} | ${row.shortDescr}`,
        pgmCd: rebateProgramCd,
        qtrInfo: qtr_field_value?.qtrInfo,
        uraInfo: qtr_field_value?.uraInfo,
      };
      dispatch(getArSummaryByQtr(payload, fieldObj));
    }
  };
  // get ar summary quarter data from redux
  React.useEffect(() => {
    if (ar_smry_qtr) {
      goToArSummaryQtr(props.history, rebate_list_code, dispatch);
      dispatch({ type: actiontype.AR_SMRY_FOR_QTR, payload: null });
    }
  }, [ar_smry_qtr]);

  let thirdInfo = `Rebate Program: All | All Rebate Programs`;
  let fourthInfo = `Quarter Range: ${qtr_field_value?.qtrInfo}`;
  let firstInfo = `Unallocated Balance: ${
    unallocatedBlnQtr < 0
      ? `(${formatter.format(-unallocatedBlnQtr).replace(/^(\D+)/, '$1 ')})`
      : `${formatter.format(unallocatedBlnQtr).replace(/^(\D+)/, '$1 ')}`
  }`;
  let secondInfo = `URA Used: ${qtr_field_value?.uraInfo}`;

  return (
    <div className="tabs-container ARScreen" data-testid="ARSummaryByQtrAll">
      <Spinner load={load} />
      <CustomSeparator parent1="Research" parent2="AR Summary By Qtr" />
      <div className="row">
        {!fullScreenView && (
          <div className="col-12">
            <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
              <div className="row">
                <div className="col-12 col-sm-6 col-lg-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="rebateProgram"
                      label={rebateProgramLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value="All | All Rebate Programs"
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-3">
                  <div className="mui-custom-form">
                    <OverlayTrigger placement="top" overlay={renderTooltip}>
                      <TextField
                        id="quarter"
                        label={quarterRangeLabel}
                        disabled
                        placeholder=""
                        InputLabelProps={{
                          shrink: true,
                        }}
                        inputProps={{ maxLength: 10 }}
                        value={
                          qtr_field_value?.qtrInfo.indexOf('DRAMS') !== -1 ||
                          qtr_field_value?.qtrInfo.indexOf('First') !== -1
                            ? `${qtr_field_value?.qtrInfo?.substring(0, 20)}...`
                            : qtr_field_value?.qtrInfo
                        }
                      />
                    </OverlayTrigger>
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="unallocatedBalance"
                      label={unallocatedBalanceLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      className={unallocatedBlnQtr < 0 ? 'negative-value' : ''}
                      value={`${
                        unallocatedBlnQtr < 0
                          ? `(${formatter
                              .format(-unallocatedBlnQtr)
                              .replace(/^(\D+)/, '$1 ')})`
                          : `${formatter
                              .format(unallocatedBlnQtr)
                              .replace(/^(\D+)/, '$1 ')}`
                      } `}
                    />
                  </div>
                </div>
                <div className="col-12 col-sm-6 col-lg-3">
                  <div className="mui-custom-form">
                    <TextField
                      id="URAUsed"
                      label={URAUsedLabel}
                      disabled
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      value={qtr_field_value?.uraInfo}
                    />
                  </div>
                </div>
              </div>
            </fieldset>
          </div>
        )}
      </div>
      <div className="row">
        <div className="col-sm-12 FRR-custom-table tbl-manufacturer-inner frr-log_chk frr-display-dropdown-cell frr-yellow-bg-height bottom-pinned-bold">
          <TableGridWithFeatures
            data-testid="acc-rec-NDC-activity-grid"
            rowSelection="single"
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={() => setFullScreenView(!fullScreenView)}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            gridCall={onGridReady}
            columnDefs={ARSummryByQtrColumns.map((col) =>
              col.field === 'actions'
                ? {
                    ...col,
                    pdfExportOptions: {
                      ...(col.pdfExportOptions || {}),
                      skipColumn: true,
                    },
                  }
                : col
            )}
            rowData={
              ar_smry_qtr_tbl?.acctRecvbyQtrForAllQtrsInfo?.map((item) => {
                item.currBalance = item.currBalance
                  ? item.currBalance
                  : parseFloat(0).toFixed(2);
                item.offsetDue = item.offsetDue
                  ? item.offsetDue
                  : parseFloat(0).toFixed(2);
                item.baseStateAmountDue = item.baseStateAmountDue
                  ? item.baseStateAmountDue
                  : parseFloat(0).toFixed(2);
                item.interestDue = item.interestDue
                  ? item.interestDue
                  : parseFloat(0).toFixed(2);
                item.totalDue = item.totalDue
                  ? item.totalDue
                  : parseFloat(0).toFixed(2);
                item.amtPaid = item.amtPaid
                  ? item.amtPaid
                  : parseFloat(0).toFixed(2);
                item.offsetPaidAmt = item.offsetPaidAmt
                  ? item.offsetPaidAmt
                  : parseFloat(0).toFixed(2);
                item.baseStatePaidAmount = item.baseStatePaidAmount
                  ? item.baseStatePaidAmount
                  : parseFloat(0).toFixed(2);
                item.interestPaid = item.interestPaid
                  ? item.interestPaid
                  : parseFloat(0).toFixed(2);
                item.currInvAMt = item.currInvAMt
                  ? item.currInvAMt
                  : parseFloat(0).toFixed(2);
                item.currRoa = item.currRoa
                  ? item.currRoa
                  : parseFloat(0).toFixed(2);
                item.baseStateRebateAmt = item.baseStateRebateAmt
                  ? item.baseStateRebateAmt
                  : parseFloat(0).toFixed(2);
                item.origInvAMt = item.origInvAMt
                  ? item.origInvAMt
                  : parseFloat(0).toFixed(2);

                return item;
              }) || []
            }
            pinnedBottomRowData={
              ar_smry_qtr_tbl?.acctRecvbyQtrForAllQtrsInfo?.length > 0
                ? pinned
                : undefined
            }
            info={{
              firstInfo,
              secondInfo,
              thirdInfo,
              fourthInfo,
            }}
            noGlobalSort
            hideColumnsInPdf={['actions']}
            exportFile
            animateRows
            sideBar={false}
            fileName={ARSummaryByQtrrLabel}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            isScrollOn
            enterMovesDown
            suppressCellFocus
            onCellFocused={onCellFocused}
            getFilterApply={getFilterApply}
            onFilterData={onFilterChanged}
            frameworkComponents={frameworkComponents}
          />
        </div>
      </div>
      {/* <CommonModal
        open={showRebateProgramList}
        viewAction
        viewHeader
        modalTitle="Select Rebate Program"
        className="panel-header"
        okTitle="Ok"
        closeTitle="Close"
        onOk={() => {
          setShowRebateProgramList(false);
          redirectRebateList();
        }}
        onClose={() => {
          setShowRebateProgramList(false);
        }}
        childrenComponent={
          <TableGridWithFeatures
            data-testid="acc-rec-rebate-program-grid"
            rowSelection={'single'}
            rowMultiSelectWithClick={false}
            fullScreenView={fullScreenView}
            handleFullScreenViewClick={() => setFullScreenView(!fullScreenView)}
            gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
            gridCall={onGridReady}
            onSelect={onRowSelect}
            columnDefs={rebateProgramListColumns}
            rowData={rebate_list || []}
            exportFile={false}
            animateRows={true}
            sideBar={false}
            fileName={selectRebateProgramLabel}
            navigateToNextCell={navigateToNextCell}
            tabToNextCell={tabToNextCell}
            enterMovesDown={true}
            suppressCellFocus={true}
            onCellFocused={onCellFocused}
            onFilterData={false}
            frameworkComponents={[]}
            cellClickedListener={(val) => {
              onRowSelect(val);
              setShowRebateProgramList(false);
              redirectRebateList();
            }}
          />
        }
      /> */}
    </div>
  );
};

export default ARSummaryByQtrAll;
